import { IInjectable } from '@uirouter/angularjs';
import { IQService } from 'angular';

export function LoadCssResolver(options: { url: string; id: string }): IInjectable {
  return [
    '$q',
    function ($q: IQService) {
      const q = $q.defer();

      let ticks = 0;
      const linkElement = $('#' + options.id);
      const link = linkElement.length === 0 ? document.createElement('link') : linkElement.get(0)!;

      link.setAttribute('rel', 'stylesheet');
      link.setAttribute('type', 'text/css');
      link.setAttribute('id', options.id);
      link.setAttribute('href', options.url);

      const onReadyStateChange = function () {
        q.resolve('done');
      };

      const checkTimer = function () {
        for (let i = 0; i < document.styleSheets.length; i++) {
          const sheet = document.styleSheets[i].href;
          if (sheet !== null && sheet.substr(sheet.length - options.url.length) == options.url) {
            return onReadyStateChange();
          }
        }

        if (ticks < 200) {
          setTimeout(checkTimer, 50);
          ticks++;
        } else {
          q.reject('fail');
        }
      };

      if (document.all) {
        // Uses onreadystatechange for Internet Explorer
        (link as any).attachEvent('onreadystatechange', function () {
          const readyState = (link as any).readyState;
          if (readyState == 'complete' || readyState == 'loaded') {
            onReadyStateChange();
          }
        });
      } else {
        // Checks if the stylesheet has been loaded every 50 ms for others
        setTimeout(checkTimer, 50);
      }

      $('head:first').append(link);

      return q.promise;
    },
  ];
}
